export const COLORS = {
  primary: '#5057d5',
  primaryLight: '#e8f0fe',
  surface: '#ffffff',
  background: '#f8f9fa',
  text: '#202124',
  textSecondary: '#5f6368',
  textMuted: '#80868b',
  border: '#dadce0',
  borderLight: '#e8eaed',
  success: '#1e8e3e',
  error: '#d93025',
  white: '#ffffff'
}

export const EMPTY_REFERENCE_IMAGES = []

export const blurActiveElement = () => {
  if (typeof document === 'undefined') return

  const activeElement = document.activeElement
  if (activeElement && typeof activeElement.blur === 'function') {
    activeElement.blur()
  }
}

export const releaseModalFocus = next => {
  blurActiveElement()

  if (typeof window !== 'undefined' && window.requestAnimationFrame) {
    window.requestAnimationFrame(() => {
      if (typeof next === 'function') next()
    })
    return
  }

  if (typeof next === 'function') {
    setTimeout(next, 0)
  }
}

export const wait = ms => new Promise(resolve => setTimeout(resolve, ms))
